import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["adjustments", "template"]

  connect() {
    // if (this.adjustmentsTarget.children.length === 0) {
    //   this.addAdjustment()
    // }
    this.renumberAdjustments()
  }

  renumberAdjustments() {
    const adjustments = Array.from(this.adjustmentsTarget.children)
    adjustments.forEach((adjustmentElement, index) => {
      const position = (index + 1) * 10 // gaps for inserts
      const input = adjustmentElement.querySelector("input[name*='[position]']")
      if (input) input.value = position

      const tmp = adjustmentElement.querySelector(".postemp")
      if (tmp) tmp.textContent = position
    })
  }

  addAdjustment(event) {
    if (event) event.preventDefault()

    const fragment = this.templateTarget.content.cloneNode(true)
    const newAdjustment = fragment.querySelector(".smart-scenario-adjustment")

    // Replace placeholder with unique ID
    const uniqueId = Date.now()
    newAdjustment.innerHTML = newAdjustment.innerHTML.replace(/new_RECORD/g, `new_${uniqueId}`)

    // Always append to end
    this.adjustmentsTarget.appendChild(newAdjustment)

    this.renumberAdjustments()
  }

  removeAdjustment(event) {
    event.preventDefault()
    const adjustment = event.target.closest(".smart-scenario-adjustment")
    if (adjustment) {
      adjustment.remove()
      this.renumberAdjustments()
    }
  }

  formatAmount(event) {
    const field = event.target
    const value = parseFloat(field.value)
    if (!isNaN(value)) {
      field.value = value.toFixed(2)
    }
  }
}
